import Close from '../Icons/Close';
import cn from 'classnames';
import './Tag.scss';

/**
 * @param {{
 *   onRemove?: () => void;
 *   onClick?: () => void;
 *   disabled?: boolean;
 *   children: string,
 * }} props 
 */
const Tag = ({
  onRemove,
  onClick,
  children,
  disabled,
}) => {
  return (
    <span
      className={cn({
        'Tag': true,
        'Tag--removable': !!onRemove && !onClick,
        'Tag--clickable': !!onClick,
        'Tag--disabled': disabled,
      })}
      onClick={onClick}
    >
      <span className="Tag__Text">{children}</span>
      {onRemove && !onClick && (
        <button className="Tag__Remove" onClick={onRemove} disabled={disabled}>
          <Close />
        </button>
      )}
    </span>
  );
}

export default Tag;